import { render, staticRenderFns } from "./ModalImage.vue?vue&type=template&id=179dd0a2&scoped=true&"
import script from "./ModalImage.vue?vue&type=script&lang=js&"
export * from "./ModalImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179dd0a2",
  null
  
)

export default component.exports